module.exports = __webpack_public_path__ + "img/skill_level_10_svg.aff4d555.svg";